import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import { SCORE_OPTION } from '../constants'
import { getKeyByTypePrefix, handleHighLight } from './helper'
import { getHighLight, getMaxDate } from './thunk'

const initialState = {
  maxDate: {},
  currentScore: SCORE_OPTION.CREDIT_SCORE,
  highLight: [],
  rawHighLight: {},
  loading: {
    getHighLight: true,
  },
}

const slice = createSlice({
  name: 'portfolioInsights/segment',
  initialState,
  reducers: {
    changeCurrentScore: (state, action) => {
      state.currentScore = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMaxDate.fulfilled, (state, { payload }) => {
      state.maxDate = payload || {}
    })
    builder.addCase(getHighLight.pending, (state) => {
      state.loading.getHighLight = true
    })
    builder.addCase(getHighLight.fulfilled, (state, action) => {
      state.highLight = handleHighLight(action.payload)
      state.rawHighLight = action.payload
      state.loading.getHighLight = false
    })
    builder.addCase(getHighLight.rejected, (state, action) => {
      state.loading.getHighLight = action.payload.loading
    })
  },
})

export const { changeCurrentScore } = slice.actions

export const selectMaxDate = (state) => state[slice.name].maxDate
export const selectCurrentScore = (state) => state[slice.name].currentScore
export const selectLoading = (typePrefix) => (state) => {
  const loadingKey = getKeyByTypePrefix(typePrefix)
  return state[slice.name].loading[loadingKey]
}
export const selectHighlight = (state) => state[slice.name].highLight
export const selectRawHighLight = (state) => state[slice.name].rawHighLight

register(slice.name, slice.reducer)
